import React from 'react'
import { Icon, Form, Grid } from 'semantic-ui-react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Title } from '../components'
import { loadUsers, clearUsers, getUsersCSV } from '../../common/users/actions'
import { checkFile, clearDownload } from '../../common/downloads/actions'
import { lists } from '../../common/lib/redux-lists'
import {
  TextFilter,
  RoleFilter,
} from '../components/filters'

import { UsersTable } from '../tables'

const { Row, Column } = Grid

class UsersPage extends React.Component {
  constructor(props) {
    super(props)
    this.getCSV = this.getCSV.bind(this)
    this.checkCSV = this.checkCSV.bind(this)
  }
  componentWillReceiveProps(props) {
    const oldLocation = this.props.downloadLocation
    const oldPath = this.props.downloadPath
    const newLocation = props.downloadLocation
    const newPath = props.downloadPath

    if (oldLocation !== newLocation && newLocation !== '') {
      props.checkFile(newLocation)
      this.checkCSVInterval = window.setInterval(this.checkCSV, 500)
    } else if (oldPath !== newPath && newPath !== '') {
      window.clearInterval(this.checkCSVInterval)
    }
  }
  componentWillUnmount() {
    const { waitingForDownload, clearDownload, clearUsers, list } = this.props
    clearUsers()
    if (waitingForDownload) clearDownload()
    if (this.checkCSVInterval) window.clearInterval(this.checkCSVInterval)
  }
  getCSV() {
    const { list, getUsersCSV } = this.props
    const query = list.$query()
    getUsersCSV(query)
  }
  checkCSV() {
    const { checkFile, downloadLocation } = this.props
    checkFile(downloadLocation)
  }
  render() {
    const {
      users, meta, list, waitingForDownload, downloadPath, clearDownload, viewer,
    } = this.props
    return (
      <div>
        <Title message="Uživatelé" />
        <aside className="breadcrumbs">
          <span>Uživatelé</span>

          <div className="options">
            <Link to="/users/new"><button><Icon name="add" /> Nový uživatel</button></Link>
          </div>
        </aside>
        <main className="content">
          <Form className="filters" size="big">
            <Grid>
              <Row columns={4}>
                <Column>
                  <strong>Příjmení:</strong>
                  <TextFilter {...list.filters['lastNameSort.likeCollateStart']} />
                </Column>
                <Column>
                  <strong>Jméno:</strong>
                  <TextFilter {...list.filters['firstNameSort.likeCollateStart']} />
                </Column>
                <Column>
                  <strong>Email:</strong>
                  <TextFilter {...list.filters['email.like']} />
                </Column>
                <Column>
                  <strong>Role:</strong>
                  <RoleFilter multiple {...list.filters['role.in']} />
                </Column>
              </Row>
            </Grid>
          </Form>
          <UsersTable
            users={users}
            meta={meta}
            list={list}
            getCSV={['ADMIN','SUPERVISOR'].indexOf(viewer.role) !== -1 && this.getCSV}
            waitingForDownload={waitingForDownload}
            csv={downloadPath}
            clearDownload={clearDownload}
          />
        </main>
      </div>
    )
  }
}

UsersPage.defaultProps = {
  waitingForDownload: false,
  downloadPath: '',
  downloadLocation: '',
}

UsersPage.propTypes = {
  viewer: React.PropTypes.object.isRequired,
  users: React.PropTypes.object.isRequired,
  meta: React.PropTypes.object.isRequired,
  loadUsers: React.PropTypes.func.isRequired,
  clearUsers: React.PropTypes.func.isRequired,
  list: React.PropTypes.object.isRequired,
  waitingForDownload: React.PropTypes.bool,
  downloadPath: React.PropTypes.string,
  downloadLocation: React.PropTypes.string,
  getUsersCSV: React.PropTypes.func.isRequired,
  checkFile: React.PropTypes.func.isRequired,
  clearDownload: React.PropTypes.func.isRequired,
}

UsersPage = lists(UsersPage, {
  path: 'UsersPage',
  filters: ['firstNameSort.likeCollateStart', 'lastNameSort.likeCollateStart', 'email.like', 'role.in'],
  headings: ['firstNameSort', 'lastNameSort', 'email', 'role'],
  debounceTime: 50,
  loadDataAction: (props) => (props.loadUsers),
  getInitialState: () => ({
    sort: 'lastName',
  })
})

export default connect((state) => ({
  viewer: state.users.viewer,
  users: state.users.all,
  meta: state.users.meta,
  waitingForDownload: state.downloads.downloading,
  downloadPath: state.downloads.path,
  downloadLocation: state.downloads.location,
}), { loadUsers, clearUsers, getUsersCSV, checkFile, clearDownload })(UsersPage)



// WEBPACK FOOTER //
// ./src/browser/pages/Users.js